import { z } from 'zod';
import { dbEntityInsertSchema } from './db-entity';
import { entitySchema } from './entity';

export const createEntityRequestSchema = z.object({
  entity: dbEntityInsertSchema,
  secondaryEntities: z.array(dbEntityInsertSchema).optional(),
});

export type CreateEntityRequest = z.infer<typeof createEntityRequestSchema>;

export const createEntityResponseSchema = entitySchema;

export type CreateEntityResponse = z.infer<typeof createEntityResponseSchema>;
